import { DEFAULT_OPERATOR, EXAMPLE_OPERATOR_OPTIONS, EXAMPLE_OPTIONS, EXAMPLE_OPTIONS_CAMPAIGN, } from '../LightweightFilterMenu/LightweightFilterMenu.constants';
export const DEFAULT_MAX_FILTERED_FIELD_NAMES = 8;
export const DEFAULT_FILTER_OPTIONS = [];
export const STORY_VALUE = {
    'Ad partner': { values: [], operator: DEFAULT_OPERATOR },
    Campaign: { values: [], operator: DEFAULT_OPERATOR },
    Platform: { values: [], operator: DEFAULT_OPERATOR },
};
export const STORY_FIELD_NAMES = [
    {
        fieldNameOption: { value: 'Ad partner', label: 'Ad partner label' },
        filterOptions: EXAMPLE_OPTIONS,
        disableRemove: true,
        isLoading: false,
        hideSelectAll: false,
    },
    {
        fieldNameOption: { value: 'Campaign', label: 'Campaign' },
        filterOptions: EXAMPLE_OPTIONS_CAMPAIGN,
        disableRemove: true,
        isLoading: false,
        hideSelectAll: true,
    },
    {
        fieldNameOption: { value: 'Platform', label: 'Platform' },
        filterOptions: [],
        disableRemove: false,
        isLoading: false,
        operatorOptionsOverride: [
            EXAMPLE_OPERATOR_OPTIONS[0],
            EXAMPLE_OPERATOR_OPTIONS[1],
        ],
    },
    {
        fieldNameOption: { value: 'ad id', label: 'ad id' },
        filterOptions: [],
        isLoading: true,
    },
    {
        fieldNameOption: { value: 'ad name', label: 'ad name' },
        filterOptions: [],
        isLoading: false,
    },
    {
        fieldNameOption: { value: 'agency name', label: 'agency name' },
        filterOptions: [],
        isLoading: false,
    },
    {
        fieldNameOption: { value: 'agency id', label: 'agency id' },
        filterOptions: [],
        isLoading: false,
    },
    {
        fieldNameOption: { value: 'channel', label: 'channel' },
        filterOptions: [],
        isLoading: false,
    },
    {
        fieldNameOption: { value: 'region', label: 'region' },
        filterOptions: [],
        isLoading: false,
    },
    {
        fieldNameOption: { value: 'ad set it', label: 'ad set it' },
        filterOptions: [],
        isLoading: false,
    },
];
//# sourceMappingURL=LightweightFilters.constants.js.map